var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DataService = {
    getComplexById: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const url = window.languageBase + 'complexdetails' + '?path-segment=' + id;
        return DataService._call(url)
            .then((unit) => {
            unit.contacts = Object.values(unit.contacts);
            return unit;
        })
            .catch((err) => {
            throw err;
        });
    }),
    getUnitById: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const url = window.languageBase + 'unitdetails' + '?path-segment=' + id;
        return DataService._call(url)
            .then((unit) => {
            unit.contacts = Object.values(unit.contacts);
            return unit;
        })
            .catch((err) => {
            throw err;
        });
    }),
    _call: (url) => __awaiter(void 0, void 0, void 0, function* () {
        return fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            redirect: 'follow',
            referrer: 'no-referrer',
        })
            .then((response) => {
            if (response.status === 200) {
                return response.json();
            }
            throw response;
        })
            .catch((err) => {
            console.error(err);
            throw err;
        });
    }),
};
export default DataService;
